import React from "react";
import { Breadcrumb, IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";

interface ITopBannerProps {
    breadcrumbItems?: IBreadcrumbItem[];
}

export const TopBannerCustomSignIn: React.FC<ITopBannerProps> = ({ breadcrumbItems }) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                padding: "0 20px",
                height: 48,
                backgroundColor: "#F4F5F7",
            }}
        >
            {breadcrumbItems && breadcrumbItems.length > 0 && (
                <Breadcrumb
                    items={breadcrumbItems}
                    ariaLabel="Navigation breadcrumb"
                    overflowAriaLabel="More links"
                    overflowIndex={breadcrumbItems.length > 1 ? 1 : 0}
                    styles={{
                        root: { width: "100%", color: "black", margin: 0 },
                        itemLink: {
                            color: "black",
                            fontSize: 15,
                            fontWeight: 'normal',
                            selectors: {
                                ':hover': { backgroundColor: '#E8E9EB', cursor: 'pointer' }
                            }
                        },
                        item: {
                            color: "black",
                            fontSize: 15,
                            fontWeight: 'normal',
                        },
                        chevron: { color: "black" }
                    }}
                />
            )}
        </div>
    );
};